import { Label } from '@/lib';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type CSVHeaderRowRadioProps = {
  labelKey: TranslationKeys;
  labelFor: string;
  value: string;
  checked: boolean;
  onChange: VoidFunction;
};

export const CSVHeaderRowRadio: FC<CSVHeaderRowRadioProps> = ({ labelKey, labelFor, value, checked, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center gap-2 rounded-xl border p-4'>
      <input id={labelFor} type='radio' className='form-radio cursor-pointer' name='radio' value={value} checked={checked} onChange={onChange} />
      <Label className='cursor-pointer p-0.5' htmlFor={labelFor}>
        {t(toRuntimeTranslationKey(labelKey) as any)}
      </Label>
    </div>
  );
};
